
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../util';
import CellUi from '../cell/CellUi';

declare var window: WindowType;

@Component({
  components: {
    CellUi,
    AreaUi: require('../area/area.vue.html').default,
    Config: require('../configuration/config.vue.html').default,
    LineUi: require('../line/line.vue.html').default,
    LinksUi: require('../Maintanence/links/links.vue.html').default,
    Oee: require('../oee/oeeconfig.vue.html').default,
    Shift: require('../oeeshift/oeeshift.vue.html').default,
  },
})
export default class OeeConfigUi extends Vue {
  selectedIndex = 0;

  get isMaintenance(): boolean {
    return window.application.check2.isMaintenanceMode;
  }

  get labels(): { name: string } [] {
    if (this.isMaintenance) {
      return [
        { name: this.$i18n.t('txtCell').toString() },
        { name: this.$i18n.t('Lines').toString() },
        { name: this.$i18n.t('txtArea').toString() },
        { name: this.$i18n.t('txtEvents').toString() },
        { name: this.$i18n.t('txtLinks').toString() },
        { name: this.$i18n.t('txtOeeConfig').toString() },
        { name: this.$i18n.t('txtOeeShift').toString() },
      ];
    } else {
      return [
        { name: this.$i18n.t('txtObject').toString() },
        { name: this.$i18n.t('txtArea').toString() },
        { name: this.$i18n.t('txtArea').toString() },
        { name: this.$i18n.t('txtEvents').toString() },
        { name: this.$i18n.t('txtLinks').toString() },
        { name: this.$i18n.t('txtOeeConfig').toString() },
        { name: this.$i18n.t('txtOeeShift').toString() },
      ];
    }
  }

  mounted() {
    this.handleTabSelectTriggerByUrl();
  }

  private handleTabSelectTriggerByUrl(): void {
    let url = new URL(window.location.href);
    if (url.searchParams.has('duty')) {
      this.selectedIndex = 2;
    } else if (url.searchParams.has('oeesetting')) {
      this.selectedIndex = 5;
    }
  }

  selectLabel(index: number): void {
    this.selectedIndex = index;
  }
}
